module.exports = "<button type=\"button\" class=\"navbar-toggler\" style=\"display: block\" (click)=\"sideNavService.toggleSideNav()\">\n    <span class=\"navbar-toggler-icon\"></span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-side-nav-toggler/authorised-side-nav-toggler.component.html
// module id = ../../../../../src/app/layout/authorised/authorised-side-nav-toggler/authorised-side-nav-toggler.component.html
// module chunks = main